class ProfilePageActionTypes {}
ProfilePageActionTypes.PROFILE_PAGE_LOADING = "PROFILE_PAGE_LOADING"
ProfilePageActionTypes.PERSONAL_DETAILS_PAGE_LOADING = "PERSONAL_DETAILS_PAGE_LOADING"
ProfilePageActionTypes.UPDATE_CURRENT_USER_RESPONSE = "UPDATE_CURRENT_USER_RESPONSE"
ProfilePageActionTypes.OPEN_CROP_PAGE = "OPEN_CROP_PAGE"
ProfilePageActionTypes.CLOSE_CROP_PAGE = "CLOSE_CROP_PAGE"
ProfilePageActionTypes.UPDATE_CUSTOM_INTERFACE_ROW_V2 = "UPDATE_CUSTOM_INTERFACE_ROW_V2"
ProfilePageActionTypes.UPDATE_CUSTOM_INTERFACE_SECTION_V2 = "UPDATE_CUSTOM_INTERFACE_SECTION_V2"
export default ProfilePageActionTypes
